// フィルター関連のスクリプト
document.addEventListener("DOMContentLoaded", function () {
  const categoryLinks = document.querySelectorAll(".c-works__category-link");
  const workCards = document.querySelectorAll(".c-works__card");

  categoryLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      const selectedCategory = this.dataset.category;

      // 他のすべてのリンクから 'active' クラスを削除
      categoryLinks.forEach((otherLink) => {
        otherLink.classList.remove("active");
      });

      // クリックされたリンクに 'active' クラスを追加
      this.classList.add("active");

      workCards.forEach((card) => {
        if (
          selectedCategory === "all" ||
          card.dataset.category === selectedCategory
        ) {
          card.style.display = "block";
        } else {
          card.style.display = "none";
        }
      });
    });
  });

  // ページ読み込み時に 'All' リンクをアクティブにする
  const allLink = document.querySelector(
    '.c-works__category-link[data-category="all"]'
  );
  if (allLink) {
    allLink.classList.add("active");
  }
});